import React from 'react';
import { fromInfo } from '../../../../_providers/Translation';

function HelpInfo() {
    return (
        <div>
            {fromInfo('sms')}
        </div>
    )
}

export default HelpInfo;